import { Modal, ModalBody, ModalHeader } from "flowbite-react";

type HtmlContentModalProps = {
  show: boolean
  onClose: () => void
  title: string
  html: string | null
  contentClassName?: string
};

export const HtmlContentModal = ({
  show, onClose, title, html, contentClassName,
}: HtmlContentModalProps) => (
  <Modal show={show} dismissible onClose={onClose} size="3xl">
    <ModalHeader>{title}</ModalHeader>
    <ModalBody className="max-h-[70vh] overflow-y-auto">
      <div
        className={contentClassName ?? "prose prose-sm max-w-none dark:prose-invert"}
        dangerouslySetInnerHTML={{ __html: html ?? "" }}
      />
    </ModalBody>
  </Modal>
);

HtmlContentModal.displayName = "HtmlContentModal";
